import { clsx } from 'clsx'
import { NavLink, matchPath } from 'react-router-dom'

import { LinkIcon } from '~/appComponents/LinkIcon.tsx'

import type { Link } from '../utils/getLinks'

interface Props {
  link: Link
}

const MenuLink = (props: Props) => {
  const {
    link: { title, url, type },
  } = props

  const matchDashboard = matchPath({ path: '/c/:workspace', end: true }, url)

  return (
    <li className="main-menu__item">
      <NavLink
        to={url}
        end={!!matchDashboard}
        className={({ isActive }) =>
          clsx({
            [`main-menu__link`]: true,
            [`main-menu__link--${type}`]: true,
            [`main-menu__link--active`]: isActive,
          })
        }
      >
        <div className="main-menu__icon main-menu__icon--default">
          <LinkIcon type={type} />
        </div>
        <div className="main-menu__icon main-menu__icon--active">
          <LinkIcon type={type} />
        </div>
        <span className="main-menu__item-name">{title}</span>
      </NavLink>
    </li>
  )
}
export default MenuLink
